import type { LegalPage, LanguageKey } from "@akina/domain";
import { type ApiConfiguration } from "../shared";
import type { CMSStory } from "../../adapters";

const getSlug = (key: LegalPage["key"], language?: LanguageKey | null) =>
  language ? `${key}-${language.toLowerCase()}` : key;

export const legalPageApi = (config: ApiConfiguration) => ({
  async getLegalPage(
    key: LegalPage["key"],
    app: "care" | "portal",
    language?: LanguageKey | null,
  ): Promise<LegalPage | undefined> {
    const response = await config.cmsService.get<{
      title: string;
      subtitle: string;
      version: string;
      date: string;
      content: string;
      preContent?: string;
      PDF?: {
        filename: string;
      };
    }>(
      app === "care"
        ? config.cmsEndpoints.careLegalPage(getSlug(key, language))
        : config.cmsEndpoints.portalLegalPage(getSlug(key, language)),
    );

    const story = response.data.stories[0];

    if (!story) return undefined;

    return {
      key: key,
      title: story.content.title,
      subtitle: story.content.subtitle,
      version: story.content.version,
      date: new Date(story.content.date),
      content: story.content.content,
      pdfUrl: story.content.PDF?.filename,
      preContent: story.content.preContent,
    };
  },
  async getIFULanguages(): Promise<{ name: string; key: LanguageKey }[]> {
    const response = await config.cmsService.get<{ Text: string }>(config.cmsEndpoints.ifuLanguages);

    const stories = response.data.stories;

    if (!stories) return [];

    return stories.map((s: CMSStory<{ Text: string }>) => ({
      name: s.content.Text,
      key: s.slug as LanguageKey,
    }));
  },
});

export * from "./useFetchIFULanguages";
export * from "./useFetchLegalPage";
export * from "./useFetchTermsAndConditionsStatus";
export * from "./useNavigateToTermsAndConditions";
export * from "./useUpdateTermsAndConditionsStatus";
